import { UserList, UserShow } from "../users";

export const OrgUsersList = (props) => {
  return <UserList title="My Users" {...props} />;
};

export const OrgUsersShow = () => {
  return <UserShow />;
};
